import { createApp } from 'vue'
import Luhn from './Luhn.vue'
import './assets/global.css'

createApp(Luhn).mount('#luhn')
